import { Colors } from '../consts/Colors';
import { Sizes } from '../consts/Sizes';
import ButtonRounded from './ButtonRounded';

export default class BurgerMenu extends Phaser.GameObjects.Container {
    constructor(scene, x, y, activeScene, menuName, menuItems) {
        super(scene, x, y);
        scene.add.existing(this);
        this.menuItems = menuItems;
        this.scene = scene;
        this.isOpen = false;
        this.menuWidth = 400;
        this.menuHeight = scene.scale.height;
        this.activeScene = activeScene;

        // creer rectangle de fond de l'icone menu
        this.burgerBackground = scene.add
            .rexRoundRectangle(x, y, 70 * 2.5, 64, 30, Colors.Elmt.BleuNovotel)
            .setOrigin(0.5)
            .setAlpha(1);

        // add texte menu
        this.burgerText = scene.add
            .text(x + 25, y, menuName, {
                fontSize: Sizes.Text.h4,
                fontFamily: 'Monteserrat',
                color: Colors.Text.White,
                wordWrap: { width: 200 },
                align: 'left',
            })
            .setOrigin(0.5)
            .setAlpha(1);

        // 🔹 Créer l'icône burger
        this.burgerIcon = scene.add
            .image(x - 55, y - 2, 'burger')
            .setInteractive({ useHandCursor: true });
        this.burgerIcon.setScale(0.8);
        this.burgerIcon.on('pointerdown', () => this.toggleMenu());

        // 🔹 Créer le menu (caché au départ)
        this.menuContainer = scene.add.container(scene.scale.width, 0);

        // 🔹 Fond du menu
        this.menuBackground = scene.add.rectangle(
            this.menuWidth / 2,
            this.menuHeight / 2,
            this.menuWidth,
            this.menuHeight,
            Colors.Elmt.BleuNovotel
        );
        this.menuBackground.setOrigin(0.5);
        this.menuBackground.setDepth(0);

        // 🔹 Bouton de fermeture (X)
        this.closeButton = scene.add
            .image(this.menuWidth - 40, 40, 'close') // 40px de padding à droite
            .setInteractive({ useHandCursor: true });
        this.closeButton.setScale(0.8);
        this.closeButton.on('pointerdown', () => this.toggleMenu());

        // 🔹 Ajouter la liste des éléments du menu
        this.createMenuItems();

        // 🔹 Ajouter tout au container
        this.menuContainer.addAt(this.menuBackground, 0); // S'assurer qu'il est derrière
        this.menuContainer.add(this.closeButton);

        this.scene.add.existing(this.menuContainer);

        this.bringToTop();
        this.menuContainer.setDepth(100);
        this.setDepth(200);
    }

    createMenuItems() {
        let startY = 80;
        let iconOffsetX = 100;
        let textOffsetX = 150;
        let lineHeight = 100;

        this.menuItemElements = []; // à utiliser dans animateMenuItems

        this.menuItems.forEach((item, index) => {
            const yPos = startY + index * lineHeight;

            const menuItemContent = this.scene.add
                .rexRoundRectangle(
                    this.menuWidth / 2,
                    yPos,
                    this.menuWidth - 80,
                    lineHeight - 120,
                    50,
                    this.activeScene === index + 1 ? Colors.Elmt.White : Colors.Elmt.BleuNovotel
                )
                .setAlpha(0)
                .setScale(0.95);

            const menuItem = this.scene.add
                .text(textOffsetX, yPos, item.label, {
                    fontSize: Sizes.Text.h2,
                    fontFamily: 'WWF',
                    color:
                        this.activeScene === index + 1
                            ? Colors.Text.BleuNovotel
                            : Colors.Text.White,
                    wordWrap: { width: this.menuWidth - 160 },
                    align: 'left',
                })
                .setOrigin(0, 0.5)
                .setAlpha(0)
                .setDepth(10)
                .setScale(0.95)
                .setInteractive({ useHandCursor: true });

            menuItem.on('pointerdown', () => {
                this.scene.scene.restart(); // Redémarre la scène actuelle
                this.scene.scene.start(item.scene);
                this.toggleMenu();
            });

            this.menuContainer.add([menuItemContent, menuItem]);
            this.menuItemElements.push(menuItemContent, menuItem); // pour animateMenuItems
        });
    }

    toggleMenu() {
        if (this.isOpen) {
            this.menuContainer.list.forEach((child, index) => {
                if (child !== this.menuBackground && child !== this.closeButton) {
                    this.scene.tweens.add({
                        targets: child,
                        alpha: 0,
                        scale: 0.95,
                        ease: 'Cubic.easeIn',
                        duration: 200,
                        delay: index * 30,
                    });
                }
            });

            this.scene.tweens.add({
                targets: this.menuContainer,
                x: this.scene.scale.width,
                duration: 500,
                ease: 'Cubic.easeInOut',
            });
        } else {
            this.menuContainer.list.forEach((child, index) => {
                if (child !== this.menuBackground && child !== this.closeButton) {
                    child.setAlpha(0);
                    child.setScale(0.95);
                }
            });

            this.scene.tweens.add({
                targets: this.menuContainer,
                x: this.scene.scale.width - this.menuWidth,
                duration: 500,
                ease: 'Cubic.easeInOut',
                onComplete: () => {
                    this.animateMenuItems();
                },
            });
        }

        this.isOpen = !this.isOpen;
    }

    animateMenuItems() {
        let delay = 0;

        this.menuItemElements.forEach((el) => {
            this.scene.tweens.add({
                targets: el,
                alpha: 1,
                scale: 1,
                ease: 'Back.easeOut',
                duration: 300,
                delay: delay,
            });

            delay += 50;
        });
    }
    showLoadingOverlay() {
        const overlay = this.scene.add
            .rectangle(
                this.scene.scale.width / 2,
                this.scene.scale.height / 2,
                this.scene.scale.width,
                this.scene.scale.height,
                Colors.Elmt.Black
            )
            .setAlpha(0.8)
            .setDepth(999);

        const loadingText = this.scene.add
            .text(this.scene.scale.width / 2, this.scene.scale.height / 2, 'Loading...', {
                fontSize: Sizes.Text.h2,
                fontFamily: 'Montserrat',
                color: Colors.Text.White,
            })
            .setOrigin(0.5)
            .setDepth(1000);

        return { overlay, loadingText };
    }
}
